<template>
  <v-container>
    <v-layout row justify-center>
      <v-flex xs8 mb-6>
        <v-card v-if="visibleUsers">
          <v-card-title v-html="$t('loginSelectUser')" class="grey--text"/>
          <v-list v-if="visibleUsers">
            <template v-for="(user, index) in visibleUsers">
              <v-list-tile :key="user.id" avatar @click="selectUser(user)">
                <v-list-tile-action>
                  <v-icon v-if="currentUser && user.id == currentUser.id" color="green">check</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span v-if="user.isPasswordRequired">
                      <v-icon small v-if="currentUser && currentUser.id == user.id">lock_open</v-icon>
                      <v-icon small v-else>lock</v-icon>
                    </span>
                    {{user.fullName}}
                  </v-list-tile-title>
                  <v-list-tile-sub-title v-if="user.isAdmin">
                    <span>
                      <v-icon small v-if="currentUser &&  currentUser.id == user.id">lock_open</v-icon>
                      <v-icon small v-else>lock</v-icon>Admin
                    </span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>

              </v-list-tile>
              
              <v-divider v-if="index < visibleUsers.length -1" :key="index"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-flex xs6 mb-6>
        <div v-if="!currentUser && visibleUsers.length == 0">
          <v-layout row pt-3 justify-center>
              <v-flex xs8 >
                <v-btn block color="primary" dark @click="login">{{$t('loginWithPassword')}}</v-btn>
              </v-flex>
          </v-layout>
        </div>
        <div v-if="currentUser">
          <v-layout row pt-3 justify-center>
            <v-flex xs4 >
              <v-btn block color="primary" dark @click="logout">{{$t('logout')}}</v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <!-- make template? -->
    <v-dialog
        v-model="dialog"
        width="500"
      >

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          <span>
            {{$t('login')}}
          </span>
        </v-card-title>
        <v-card-text>
          <div v-if="loginCommunicationText">
            <span class="red--text">{{loginCommunicationText}}</span>
          </div>
          <v-flex xs12>
            <v-form v-model="valid" @submit="authAsAdmin(email, password)" onSubmit="return false">
              <v-text-field
                ref="email"
                v-model="email"
                :rules="emailRules"
                :label="$t('email')"
                required
                @keyup.escape="closeDialog()"
                @keyup.enter="emailFieldEnter()"
              ></v-text-field>
              <v-text-field
                ref="emailpassword"
                v-model="password"
                :append-icon="show1 ? 'visibility_off' : 'visibility'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                :label="$t('password')"
                :error="passwordError"
                counter
                @click:append="show1 = !show1"
                @keyup.escape="closeDialog()"
                @keyup.enter="authAsAdmin(email, password)"
              ></v-text-field>

            </v-form>
          </v-flex>
        </v-card-text>
        

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="grey-lighten-3"
            flat
            @click= "closeDialog()"
          >
            {{$t('cancel')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green-lighten-3"
            flat
            @click="authAsAdmin(email, password)"
          >
            {{$t('login')}}
          </v-btn>
        </v-card-actions>
        
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="publicUserPasswordDialog"
        width="500"
      >

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          <span>
            {{$t('login')}}
          </span>
        </v-card-title>
        <v-card-text>
          <div v-if="loginCommunicationText">
            <span class="red--text">{{loginCommunicationText}}</span>
          </div>
          <v-flex xs12>
            <v-form v-model="valid" @submit="authAsPublicWithPassword(password)" onSubmit="return false">
              <v-text-field
                ref="password"
                v-model="password"
                :append-icon="show1 ? 'visibility_off' : 'visibility'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                :label="$t('password')"
                :error="passwordError"
                counter
                @click:append="show1 = !show1"
                @keyup.escape="closeDialog()"
              ></v-text-field>

            </v-form>
          </v-flex>
        </v-card-text>
        

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="grey-lighten-3"
            flat
            @click= "closeDialog()"
          >
            {{$t('cancel')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green-lighten-3"
            flat
            @click="authAsPublicWithPassword(password)"
          >
            {{$t('login')}}
          </v-btn>
        </v-card-actions>
        
      </v-card>
    </v-dialog>
  </v-container>
</template>



<script>
  import { authAsAdminMutation, allUsersQuery, publicUsersQuery, authAsPublicMutation } from "@/graphql/userQueries.gql";
  export default {
    apollo: {
      publicUsers: {
        query: publicUsersQuery,
      },
      allUsers: {
        query: allUsersQuery,
        skip() {
          return !localStorage.token || !this.currentUser
        }
      }
    },
    computed: {
      currentUser() { return this.$store.state.currentUser },
      visibleUsers() {
        var visibleUsers = []
        var userNode
        if(this.publicUsers){
          for(var j in this.publicUsers.nodes){
            var user = this.publicUsers.nodes[j]
            visibleUsers.push(user)
          }
        }
        if(this.currentUser && this.currentUser.isAdmin && this.allUsers){
          for(var i in this.allUsers.nodes){
            userNode = this.allUsers.nodes[i]
            if(userNode.isAdmin){
              if(this.currentUser && this.currentUser.isAdmin && !visibleUsers.find(u => u.id == userNode.id)) {
                visibleUsers.push(userNode)
              }
            }
          }
        }
        return visibleUsers

      }
    },
    data() {
      return {
        allUsers: null,
        selectedUser: null,
        publicUserPasswordDialog: null,
        loginDialog: null,
        valid: false,
        dialog:false,
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        password: '',
        rules: {
          required: value => value == null || !!value || 'Required',
          min: v => v == null || v.length >= 4 || 'Min 4 characters',
          emailMatch: () => ('The email and password you entered don\'t match')
        },
        show1: false,
        show2: true,
        show3: false,
        show4: false,
        loginCommunicationText: null,
        passwordError: false
      };
    },
    methods: {
      emailFieldEnter() {
        this.$refs.emailpassword.focus()
      },
      authAsAdmin(emailInput, passwordInput) {
        if(!emailInput) return
        if(!passwordInput) return
        this.loginCommunicationText = null
        console.log(emailInput)
        console.log(passwordInput)
        this.clearAuthentication();
        this.$apollo.mutate({
          mutation: authAsAdminMutation,
          variables: {
            Credentials: {
              email: emailInput,
              password: passwordInput
            }
          }
        }).then((data) => {
          console.log(data)
          if(data.data.authenticate.jwtToken){
            localStorage.token = data.data.authenticate.jwtToken
            this.$store.dispatch('fetchCurrentUser')
            this.closeDialog()
            this.$router.push('/')
          } else {
            this.loginCommunicationText = "Incorrect login credentials"
            this.$refs.email.focus()
          }
        })
      },
      selectUser(user) {
        if(this.currentUser){
          if(user.id == this.currentUser.id) return
        }
        if (user.isAdmin) {
          //Open login dialog box
          console.log(`require password for user`, user);
          this.email = user.email
          this.login()
        } else if (user.isPasswordRequired){
          //Require password input for this user
          this.selectedUser = user
          this.publicUserPasswordDialog = true
          this.$nextTick(this.$refs.password.focus)
          
        } else {
          // No password required, set user to this user
          this.clearAuthentication();
          this.$apollo.mutate({
            mutation: authAsPublicMutation,
            variables: {
              AuthenticateData:{ 
                userId: user.id, 
              }
            }
          }).then((data) =>{
            console.log(data.data)
            if(data.data.authenticate.jwtToken){
              localStorage.token = data.data.authenticate.jwtToken
              this.$store.dispatch('fetchCurrentUser')
              this.$router.push('/')
            }
          })

        }
        //this.$router.push({ name: "home" }); //params: ...
      },

      authAsPublicWithPassword(password){
        this.clearAuthentication();
        this.$apollo.mutate({
          mutation: authAsPublicMutation,
          variables: {
            AuthenticateData:{ 
              userId: this.selectedUser.id, 
              password: password //Take input here obviously
            }
          }
        }).then((data) =>{
          console.log(data.data)
          if(data.data.authenticate.jwtToken){
            localStorage.token = data.data.authenticate.jwtToken
            this.$store.dispatch('fetchCurrentUser')
            this.publicUserPasswordDialog = null
            this.$router.push('/')
          } else {
            this.passwordError = true
            this.$refs.password.focus()
          }
        })
      },
      login(){
        this.password = null
        this.passwordError = false
        this.dialog = true
        this.$nextTick(this.email ? this.$refs.emailpassword.focus : this.$refs.email.focus)
      },
      logout(){
        this.clearAuthentication();
      },
      closeDialog() {
        this.dialog = this.publicUserPasswordDialog = false
        this.loginCommunicationText = null
      },
      clearAuthentication() {
          localStorage.removeItem('token')
          this.$store.commit('setCurrentUser', null)
          this.$apollo.getClient().resetStore().catch((err) => {console.log(err)})
      },
    },
    mounted() {
    },

  };
</script>